export default {
  "content": "<path d=\"M2 6.06c0-.19.1-.37.26-.49L7.2 2.12a.7.7 0 01.69-.06c.22.1.36.32.36.55v2.64H12c2.76 0 5 2.18 5 4.88 0 2.69-2.24 4.87-5 4.87H4.6a.82.82 0 01-.83-.81c0-.45.37-.81.83-.81H12a3.3 3.3 0 003.33-3.26A3.3 3.3 0 0012 6.88H8.25V9.5c0 .23-.14.45-.36.55a.7.7 0 01-.7-.06L2.27 6.55A.6.6 0 012 6.06z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "18",
    "height": "18",
    "fill": "#707070",
    "viewBox": "0 0 18 18"
  }
};